import { api } from "./client";
import type { DashboardFlightRow } from "@/types/api";

export interface FlightsListFilters {
  search: string;
  status: string;
  mission: string;
  sort: string;
  user_id: number | null;
}

export interface FlightsListPagination {
  page: number;
  page_size: number;
  page_count: number;
  total: number;
}

export interface FlightsListSummary {
  flights: number;
  imports: number;
  ready_flights: number;
  time_in_air: number;
}

export interface FlightUserOption {
  id: number;
  username: string;
  flight_count: number;
}

export interface FlightsListOut {
  rows: DashboardFlightRow[];
  missions: string[];
  statuses: string[];
  users: FlightUserOption[];
  summary: FlightsListSummary;
  filters: FlightsListFilters;
  pagination: FlightsListPagination;
}

export function getFlightsTable(params: Record<string, string | number | undefined>) {
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    qs.set(key, String(value));
  }
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return api.get<FlightsListOut>(`/api/flights/table${suffix}`);
}
